

export const getElement = (el, wrap = document) => {
  if (el == null) return undefined

  if (typeof el === 'string') {
    try {
      return wrap.querySelector(el) || undefined
    }
    catch ({ message }) {
      console.error(message)
      return undefined
    }
  }
}

export const getElements = (el, wrap = document) => {
  if (el == null) return undefined

  if (typeof el === 'string') {
    try {
      return wrap.querySelectorAll(el) || undefined
    }
    catch ({ message }) {
      console.error(message)
      return undefined
    }
  }
}

export const kebabCase = string => string
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, '-')
    .toLowerCase()

export const featuresCategories = (category) => {
  const featuresCategories = getElement(".features")
  const featureCategoryButton = getElements('#category-filter .filter-list__item', featuresCategories);
  const featureCategorySelect =  getElement("#category-filter-select select");
  const featureBlock = getElements('.features-block', featuresCategories);

  for (let i=0; i<featureBlock.length; i++) {
    featureBlock[i].dataset.category = kebabCase(featureBlock[i].dataset.category)
  }

  let activeTab = featureCategoryButton[0].dataset.category;
  featureCategorySelect.value = category ? category : activeTab;

  const checkCat = (activeTab) => {
    for (let j=0; j<featureBlock.length; j++) {
      featureBlock[j].classList.add("d-none");

      if (featureBlock[j].dataset.category.indexOf(activeTab) > -1){
        featureBlock[j].classList.remove("d-none");
      }

      if (activeTab === 'all') {
        featureBlock[j].classList.remove("d-none");
      }
    }
  }

  for (let i=0; i<featureCategoryButton.length; i++) {
    featureCategoryButton[i].addEventListener('click', () => {
      for (let k=0; k<featureCategoryButton.length; k++) {
        featureCategoryButton[k].classList.remove('filter-list__item--active')
      }
      featureCategoryButton[i].classList.add('filter-list__item--active')
      activeTab = featureCategoryButton[i].dataset.category;
      featureCategorySelect.value = activeTab;

      checkCat(activeTab);
    })
  }

  featureCategorySelect.addEventListener('change', function() { 
    document.getElementsByClassName("features")[0].scrollIntoView('.features');   
    activeTab = this.value;
    for (let i=0; i<featureCategoryButton.length; i++) {
      featureCategoryButton[i].dataset.category === activeTab
        ? featureCategoryButton[i].classList.add('filter-list__item--active')
        : featureCategoryButton[i].classList.remove('filter-list__item--active');
    }
    checkCat(activeTab);
  });
};


export const ifSelectorExist = (selector) => {
  if (selector !== null && selector !== undefined) {
    return true;
  } else {
    return false;
  }
};